import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"
import Loader from "../Loader"
import "./AskForConfirmation.css"

const oneOfRenderOrChildren = props => {
  if (props.render && props.children) {
    return new Error(
      "render has more precedence over content prop. Please check your AskForConfirmation component"
    )
  }
}

const oneOfIsOpenOrTrigger = props => {
  if (props.isOpen && props.trigger) {
    return new Error(
      `isOpen has more precedence over trigger prop. The trigger won't be visible in this case. 
      Please check your AskForConfirmation component`
    )
  }
}

export default class AskForConfirmation extends React.Component {
  static propTypes = {
    trigger: oneOfIsOpenOrTrigger,
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    render: oneOfRenderOrChildren,
    header: PropTypes.string,
    yesTextLabel: PropTypes.string,
    noTextLabel: PropTypes.string
  }

  static defaultProps = {
    header: "Please Confirm",
    yesTextLabel: "Yes",
    noTextLabel: "No"
  }

  constructor(props) {
    super(props)
    this.state = {
      pending: false
    }
  }

  onNo = () => {
    this.setState({ pending: true })
    this.props.onNo()
  }

  onYes = () => {
    this.setState({ pending: true })
    this.props.onYes()
  }

  render = () => {
    const { render, header, yesTextLabel, noTextLabel, children } = this.props
    const Trigger = this.state.trigger
    const triggerProp = Trigger ? { trigger: <Trigger /> } : {}

    return (
      <Modal
        defaultOpen={!Trigger}
        className="AskForConfirmation"
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        {...triggerProp}
      >
        <Modal.Header style={{ fontWeight: "300" }}>{header}</Modal.Header>
        <Modal.Content>
          {render ? render() : children}
          <Loader active={this.state.pending} text="" />
        </Modal.Content>
        <Modal.Actions>
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column textAlign="left">
                <Button
                  content={noTextLabel}
                  color="red"
                  fluid
                  onClick={this.onNo}
                  disabled={this.state.pending}
                />
              </Grid.Column>
              <Grid.Column textAlign="right">
                <Button
                  content={yesTextLabel}
                  primary
                  fluid
                  onClick={this.onYes}
                  disabled={this.state.pending}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Actions>
      </Modal>
    )
  }
}
